import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { skinAnalyserMessages } from '../messages';
import { StyledTitle } from '../styled';

export const Title = () => {
  return (
    <StyledTitle>
      <FormattedMessage {...skinAnalyserMessages.skinAnalyserTitle} />
    </StyledTitle>
  );
};
